import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import AlertsBurstSamples from './AlertsBurstSamples';

import Paper from '@mui/material/Paper';
import TabsContainer from '../Custom/Tabs/TabsContainer';

import BurstAlertHistory from './BurstAlertHistory';

const AlertsBurstTabs = (props, context) => {
  const {
    uiInfo,
    selectedFeature,
    selectedItem,
    featureType,
    showDetails,
    timeZone,
    selectedAlertSample,
    alertStateOptions,
    burstAlertHistory,
  } = props;

  const panelStyle = { height: 0.495 * uiInfo.pageHeight };

  const panelClasses = classNames('alert-details', { show: showDetails });

  function closePanel() {
    props.toggleDetailsVisibility(false);
    props.clearSelectedFeature();
  }

  React.useEffect(() => {
    if (selectedItem?.id) {
      props.toggleDetailsVisibility(true);
    } else {
      props.toggleDetailsVisibility(false);
    }
  }, [featureType, selectedItem, showDetails]);

  return (
    <Paper className={panelClasses} style={panelStyle}>
      <TabsContainer
        title={context.t('sensor_id_param2', { id: selectedItem?.sensor_id })}
        handleClose={closePanel}
        tabs={[
          {
            label: context.t('samples'),
            component: (
              <AlertsBurstSamples
                selectedFeature={selectedItem}
                selectedAlertSample={selectedAlertSample}
                timeZone={timeZone}
                uiInfo={uiInfo}
                options={props.options}
                samples={props.burstAlertsSamples}
                notify={props.notify}
              />
            ),
          },
          {
            label: context.t('history'),
            component: (
              <BurstAlertHistory
                options={alertStateOptions}
                history={burstAlertHistory}
                timeZone={timeZone}
                context={context}
              />
            ),
          },
        ]}
      />
    </Paper>
  );
};

AlertsBurstTabs.contextTypes = {
  t: PropTypes.func.isRequired,
};

export default AlertsBurstTabs;
